<template>
    <div id="pomission">
        <div class="top">
            <img src="~@/assets/nopomission.png" />
        </div>
        <div class="content">
             <div class="title">
                没有权限，页面将在<span>{{ miao }}</span>秒后返回主页
             </div>
        </div>
    </div>
</template>
<script>
    export default{
        name:"nopomission",
        data(){
            return{
                miao:5,
                timer:"",
            }
        },
        mounted(){
            this.ismiao()

        },
        methods:{
            ismiao(){
                this.miao=5
                 this.timer = setInterval(() => {
                     this.miao-=1;
                     if(this.miao<0){
                        clearInterval(this.timer);
                        this.$router.push({name:"home"})
                     }
                }, 1000);
            }
        }
    }
</script>
<style scoped>
    #pomission{
        width: 100%;
        height: 100%;
        float: left;
        padding: 100px 0;
    }
    #pomission .top{
        width: 150px;
        height: 150px;
        float: left;
        position: relative;
        left: 50%;
        margin-left: -75px;
    }
    #pomission .top img{
        width: 100%;
        height: 100%;
    }
    #pomission .content{
        width: 100%;
        height: 60px;
        float: left;
        margin-top: 50px;
    }
    #pomission .content .title{
        width: 100%;
        height: 100%;
        text-align: center;
        font-size: 20px;
        float: left;
        line-height: 60px;
    }
    #pomission .content .title span{
        color: red;
        font-weight: bold;
        font-size: 24px;
    }
</style>
